import React, { useEffect, useState, useCallback } from "react";
import * as Mui from "@mui/material";
import { themes } from "services/constants";
import { useSelector } from "react-redux";
import { customGetAPI } from "services/utils/CustomAPI";
import { EditEmployeeBasicInfo } from "./EditEmpBasicInfo";
import { EditEmployeePersonalInfo } from "./EditEmpPersonalInfo";
import { DoubleArrow } from "@mui/icons-material";
import { EmployeeSalaryInfo } from "../CreateUserEmployee/EmployeeSalaryInfo";


export const EditUserEmployee = ({
  onClose,
  reCallApi,
  isReactivationEdit,
  onReactivationUpdateComplete,
}) => {
  const requestCompanyId = useSelector((state) => state.tokenReducer.topbarCompanyId);
  const [buttonNotify, setButtonNotify] = useState("Basic Info");
  const { domain } = useSelector((state) => state.tokenReducer);
  const { userid } = useSelector((state) => state.hrportal);
  const [getEmployeeDetails, setGetEmployeeDetails] = useState(true);
  const [updateUserDetails, setUpdateUserDetails] = useState(true);
  const [userId, setUserId] = useState(userid);
  const [employeeDetails, setEmployeeDetails] = useState([]);
  const [getCompanyId, setGetCompanyId] = useState("");

  const getSelectedUserDetails = useCallback(
    async (id) => {
      const res = await customGetAPI(`${domain}employee/details?user_id=${id}&company_id=${requestCompanyId}`);
      if (res.ok) {
        setEmployeeDetails(res.responseDetails);
        setGetCompanyId(res?.responseDetails?.company_id);
        setUpdateUserDetails(true);
      }
    },
    [domain, requestCompanyId]
  );

  useEffect(() => {
    if (getEmployeeDetails) {
      getSelectedUserDetails(userId);
      setGetEmployeeDetails(false);
    }
  }, [getEmployeeDetails, getSelectedUserDetails, userId]);

  const renderTabContent = () => {
    switch (buttonNotify) {
      case "Basic Info":
        return (
          <EditEmployeeBasicInfo
            buttonNotify={buttonNotify}
            employeeDetails={employeeDetails}
            getSelectedUserDetails={getSelectedUserDetails}
            setButtonNotify={setButtonNotify}
            reCallApi={reCallApi}
            setUpdateUserDetails={setUpdateUserDetails}
            updateUserDetails={updateUserDetails}
            onClose={onClose}
            isReactivationEdit={isReactivationEdit}
            onReactivationUpdateComplete={onReactivationUpdateComplete}
          />
        );
      case "Personal Info":
        return (
          <EditEmployeePersonalInfo
            buttonNotify={buttonNotify}
            employeeDetails={employeeDetails}
            getSelectedUserDetails={getSelectedUserDetails}
            setButtonNotify={setButtonNotify}
            setUserId={setUserId}
            reCallApi={reCallApi}
            setUpdateUserDetails={setUpdateUserDetails}
            updateUserDetails={updateUserDetails}
            onClose={onClose}
            onReactivationUpdateComplete={onReactivationUpdateComplete}
          />
        );

      case "Salary Information":
        return (
          <EmployeeSalaryInfo
            reCallApi={reCallApi}
            onClose={onClose}
            isEditScreen={true}
            isSalaryTemplateUpdate={
              employeeDetails?.salary_template_data != null
            }
            getCompanyId={getCompanyId}
            onReactivationUpdateComplete={onReactivationUpdateComplete}
          />
        );

      default:
        alert("They have no option to view");
    }
  };

  return (
    <Mui.Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Mui.Paper elevation={0}>
        <Mui.Box>
          <Mui.Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              px: 1,
            }}
          >
            <Mui.Box sx={{ ml: 1 }}>
              <Mui.IconButton
                onClick={onClose}
                sx={{
                  color: themes?.grayColor,
                  "&:hover": {
                    backgroundColor: themes?.whiteColor,
                  },
                }}
              >
                <DoubleArrow />
              </Mui.IconButton>
            </Mui.Box>
          </Mui.Box>
        </Mui.Box>
      </Mui.Paper>

      <Mui.Box sx={{ flexGrow: 1, overflow: "auto", p: 2 }}>
        <Mui.Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2.5,
          }}
        >
          <Mui.Grid container>
            <Mui.Grid item xs={12}>
              <Mui.Grid sx={{ display: "flex", justifyContent: "center" }}>
                <Mui.ButtonGroup
                  fullWidth
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                    "& .MuiButton-root": {
                      borderRadius: 0,
                    },
                    "& .MuiButton-root:first-of-type": {},
                    "& .MuiButton-root:last-of-type": {},
                  }}
                >
                  <Mui.Button
                    variant={
                      buttonNotify === "Basic Info" ? "contained" : "outlined"
                    }
                    onClick={() => {
                      setButtonNotify("Basic Info");
                    }}
                    sx={{
                      background:
                        buttonNotify === "Basic Info"
                          ? themes?.softMutedGreen
                          : themes.shadowBackGround,
                      textTransform: "capitalize",
                      border: "none",
                      "&:hover": {
                        border: "none",
                        background:
                          buttonNotify === "Basic Info"
                            ? themes?.softMutedGreen
                            : themes.shadowBackGround,
                      },
                      color:
                        buttonNotify === "Basic Info"
                          ? "white"
                          : themes.headLine,
                    }}
                  >
                    Basic Info
                  </Mui.Button>
                  <Mui.Button
                    variant={
                      buttonNotify === "Personal Info"
                        ? "contained"
                        : "outlined"
                    }
                    onClick={() => {
                      setButtonNotify("Personal Info");
                    }}
                    sx={{
                      background:
                        buttonNotify === "Personal Info"
                          ? themes?.softMutedGreen
                          : themes.shadowBackGround,
                      textTransform: "capitalize",
                      border: "none",
                      "&:hover": {
                        border: "none",
                        background:
                          buttonNotify === "Personal Info"
                            ? themes?.softMutedGreen
                            : themes.shadowBackGround,
                      },
                      color:
                        buttonNotify === "Personal Info"
                          ? "white"
                          : themes.headLine,
                    }}
                  >
                    Personal Info
                  </Mui.Button>

                  <Mui.Button
                    variant={
                      buttonNotify === "Salary Information"
                        ? "contained"
                        : "outlined"
                    }
                    onClick={() => {
                      setButtonNotify("Salary Information");
                    }}
                    sx={{
                      background:
                        buttonNotify === "Salary Information"
                          ? themes?.softMutedGreen
                          : themes.shadowBackGround,
                      textTransform: "capitalize",
                      border: "none",
                      "&:hover": {
                        border: "none",
                        background:
                          buttonNotify === "Salary Information"
                            ? themes?.softMutedGreen
                            : themes.shadowBackGround,
                      },
                      color:
                        buttonNotify === "Salary Information"
                          ? "white"
                          : themes.headLine,
                    }}
                  >
                    Salary Information
                  </Mui.Button>
                </Mui.ButtonGroup>
              </Mui.Grid>
              <Mui.Grid
                container
                sx={{ paddingTop: 0.5, backgroundColor: themes.whiteColor }}
              >
                {renderTabContent()}
              </Mui.Grid>
            </Mui.Grid>
          </Mui.Grid>
        </Mui.Box>
      </Mui.Box>
    </Mui.Box>
  );
};
